import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { authFail } from '../../../redux/actions/authActions';
import {withTranslation} from "react-i18next";

class Topbar extends PureComponent {
  static propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
    changeSidebarVisibility: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired
  };

  render() {
    const { changeMobileSidebarVisibility, changeSidebarVisibility, t} = this.props;

    return (
      <div className="topbar">
        <div className="topbar__wrapper">
          <div className="topbar__left">
            <TopbarSidebarButton
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              changeSidebarVisibility={changeSidebarVisibility}
            />
            <Link className="topbar__logo" to="/" />
          </div>
          <div className="topbar__right">

            {this.props.auth.adopter &&
              <button className="topbar__btn">
                <Table>
                  <tbody>
                    <tr>
                      <td><span className="badge badge-success">{t('topbar.early_adopter')}</span></td>
                    </tr>
                  </tbody>
                </Table>
              </button>
            }

            <TopbarProfile
              onLogout={this.props.onLogout}
              blogs={this.props.blogs}
              auth={this.props.auth}
            />
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    blogs: state.blogs
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => dispatch(authFail())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('dashboard')(Topbar));
